import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import { MatDialogRef } from '@angular/material/dialog';
declare let $: any;
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  hide = true;
  hide1 = true;
  changepasswordForm: FormGroup;
  private changepasswordApi = environment.url + environment.changePassword;
  /**
   * Class constructor.
   * @param fb FormBuilder.
   * @param makeapi ApiService.
   * @param getdata ValueService.
   * @param notify NotifyService.
   * @param dialogRef MatDialogRef<ChangePasswordComponent>.
   */
  constructor(
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    private dialogRef: MatDialogRef<ChangePasswordComponent>
  ) {
    /**
     * Create the form group with the required fields.
     */
    this.changepasswordForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
    });
  }
  get add() {
    return this.changepasswordForm.controls;
  }
  /**
   * Initialize the component by setting the visibility of the loading indicator
   * and checking the user's role.
   */
  ngOnInit(): void {
    // Show the loading indicator
    this.getdata.isVisibleSource.next(true);

    // Check if the user has the 'Incubator' role
    this.checkRole('Incubator');
  }
  conversionDecryptOutput: any;
  conversionDecryptOutput2: any;
  /**
   * Encrypts the given plaintext using AES encryption with a 128-bit key.
   * The key is derived from the passPhrase using PBKDF2 with a salt value.
   * The encrypted ciphertext is returned as a base64-encoded string.
   * @param plainText The plaintext to be encrypted.
   * @returns The encrypted ciphertext as a base64-encoded string.
   */
  convertTextEnc(plainText: string): string {
    const iv = '297A1646BC32E036CF3C4DE1B1926A71';
    const salt =
      '32E036CF3C4DE1B192297A1646BC6A71297A164DE1B1926A716BC32E036CF3C4';
    const keySize = 128;
    const iterationCount = 1024;
    const passPhrase = 'varuvaaiencryption';
    let encrypt = '';
    const AesUtil = function (keySize: number, iterationCount: number) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    };
    AesUtil.prototype.generateKey = function (
      salt: string,
      passPhrase: string
    ) {
      const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
    AesUtil.prototype.encrypt = function (
      salt: string,
      iv: string,
      passPhrase: string,
      plainText: string
    ) {
      const key = this.generateKey(salt, passPhrase);
      const encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
    const aesUtil = new AesUtil(keySize, iterationCount);
    this.conversionDecryptOutput = encrypt = aesUtil.encrypt(
      salt,
      iv,
      passPhrase,
      plainText
    );
    return encrypt;
  }
  /**
   * Encrypts the given plaintext using AES encryption with a 128-bit key.
   * The key is derived from the passPhrase using PBKDF2 with a salt value.
   * The encrypted ciphertext is returned as a base64-encoded string.
   * @param plainText The plaintext to be encrypted.
   */
  convertTextEnc2(plainText: string): void {
    const iv = '297A1646BC32E036CF3C4DE1B1926A71'; // Initialization Vector
    const salt =
      '32E036CF3C4DE1B192297A1646BC6A71297A164DE1B1926A716BC32E036CF3C4'; // Salt for key derivation
    const keySize = 128; // Key size in bits
    const iterationCount = 1024; // Number of iterations for key derivation
    const passPhrase = 'varuvaaiencryption'; // Passphrase for key derivation
    let encrypt = '';

    /**
     * Utility class for AES encryption
     * @param keySize Size of the key in bits
     * @param iterationCount Number of iterations for key derivation
     */
    const AesUtil = function (keySize: number, iterationCount: number) {
      this.keySize = keySize / 32; // Convert bits to words
      this.iterationCount = iterationCount;
    };

    /**
     * Generates a key from the salt and passphrase
     * @param salt The salt value
     * @param passPhrase The passphrase
     * @returns The generated key
     */
    AesUtil.prototype.generateKey = function (
      salt: string,
      passPhrase: string
    ) {
      const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };

    /**
     * Encrypts the plaintext using AES encryption.
     * This method uses the salt and passphrase to derive a key,
     * and then uses the key to encrypt the plaintext using AES
     * with the given initialization vector.
     * @param salt The salt value. This is used to derive the key.
     * @param iv The initialization vector. This is used to initialize
     * the AES encryption.
     * @param passPhrase The passphrase. This is used to derive the key.
     * @param plainText The plaintext to encrypt. This is the text that
     * will be encrypted using AES.
     * @returns The encrypted text as a base64-encoded string.
     */
    AesUtil.prototype.encrypt = function (
      salt: string,
      iv: string,
      passPhrase: string,
      plainText: string
    ): string {
      // Derive the key from the salt and passphrase
      const key = this.generateKey(salt, passPhrase);
      // Encrypt the plaintext using AES
      const encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      // Return the encrypted text as a base64-encoded string
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };

    const aesUtil = new AesUtil(keySize, iterationCount);
    this.conversionDecryptOutput2 = encrypt = aesUtil.encrypt(
      salt,
      iv,
      passPhrase,
      plainText
    );
  }
  /**
   * Checks the role of the user and updates the form controls accordingly.
   * Resets the form and deletes any existing image before applying role-specific logic.
   *
   * @param name - The role name to check against (e.g., 'Incubator').
   */
  checkRole(name) {
    // Reset the form to clear existing values and validators
    this.changepasswordForm.reset();
    this.deleteImage();

    // Determine actions based on the role name
    if (name == 'Incubator') {
      // For 'Incubator' role, set roleid to 2 and apply required validators
      let getform = this.changepasswordForm.value;
      getform.roleid = 2;
      this.changepasswordForm.patchValue(getform);

      this.changepasswordForm.controls[
        'incubatorRegistrationType'
      ].setValidators([Validators.required]);
      this.changepasswordForm.controls['incubatorRegDesc'].setValidators([
        Validators.required,
      ]);
      this.changepasswordForm.controls['incubatorRegFileName'].setValidators([
        Validators.required,
      ]);
    } else {
      // For other roles, set roleid to 4 and clear validators
      let getform = this.changepasswordForm.value;
      getform.roleid = 4;
      this.changepasswordForm.patchValue(getform);

      this.changepasswordForm.controls[
        'incubatorRegistrationType'
      ].clearValidators();
      this.changepasswordForm.controls['incubatorRegDesc'].clearValidators();
      this.changepasswordForm.controls[
        'incubatorRegFileName'
      ].clearValidators();
    }

    // Update the validity of form controls after changing validators
    this.changepasswordForm.controls[
      'incubatorRegistrationType'
    ].updateValueAndValidity();
    this.changepasswordForm.controls[
      'incubatorRegDesc'
    ].updateValueAndValidity();
    this.changepasswordForm.controls[
      'incubatorRegFileName'
    ].updateValueAndValidity();
  }
  showOtherRegType = false;
  colSet = 'col-lg-12 col-md-12 col-12';
  /**
   * Updates the form controls based on the selected registration type.
   * If 'Other' is selected, additional input is required and the layout is adjusted.
   *
   * @param value - The selected registration type value.
   */
  selectRegistrationType(value) {
    let val = value;
    if (val === 'Other') {
      // Show additional input for 'Other' registration type
      this.showOtherRegType = true;
      this.colSet = 'col-lg-6 col-md-6 col-12';
      this.changepasswordForm.controls[
        'incubatorRegistrationTypeOther'
      ].setValidators([Validators.required]);
    } else {
      // Reset form for standard registration types
      this.showOtherRegType = false;
      this.colSet = 'col-lg-12 col-md-12 col-12';
      this.changepasswordForm.controls[
        'incubatorRegistrationTypeOther'
      ].setValue('');
      this.changepasswordForm.controls[
        'incubatorRegistrationTypeOther'
      ].clearValidators();
    }
    // Update form control validity
    this.changepasswordForm.controls[
      'incubatorRegistrationTypeOther'
    ].updateValueAndValidity();
  }
  /**
   * Handles the change password process.
   * Validates the form, encrypts passwords, and makes an API call to update the password.
   */
  changePass() {
    // Get form values
    let getform = this.changepasswordForm.value;

    // Encrypt current and new password
    this.convertTextEnc(getform.oldPassword);
    this.convertTextEnc2(getform.newPassword);

    // Validate the form
    if (this.changepasswordForm.invalid) {
      this.changepasswordForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
      return;
    }

    // Prepare request payload
    let req = {
      oldPassword: this.conversionDecryptOutput,
      newPassword: this.conversionDecryptOutput2,
    };

    // Make API call to change password
    this.makeapi
      .method(this.changepasswordApi, req, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide'); // Hide loader

        // Handle API response
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.dialogRef.close(); // Close dialog on success
        } else {
          this.notify.notifyError(data.responseMessage); // Show error message
        }
      });
  }
  /**
   * Closes the dialog and resets the form.
   * This function is typically called when the user clicks the cancel button.
   */
  cancelReg() {
    // Reset the form
    this.changepasswordForm.reset();
    // Close the dialog
    this.dialogRef.close();
  }
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  /**
   * Handles the file upload for the registration document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event The file upload event.
   */
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      let reader = new FileReader();
      const imagetype = this.selecetdFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];

      // Check if the file type is valid
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png' ||
        img_crt_type === 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          const spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.disName = this.selecetdFile.name;
          const getform = this.changepasswordForm.value;
          getform.incubatorRegFileName = this.selecetdFile.name;
          getform.incubatorRegFile = this.FileValue;
          this.changepasswordForm.patchValue(getform);
        };
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }
  /**
   * Deletes the uploaded image file and resets related form controls.
   * Clears file values, resets display names, and updates the form.
   */
  deleteImage() {
    // Clear stored file values and display names
    this.FileValue = '';
    this.FileName = '';
    this.disName = '';
    this.selecetdFile = '';

    // Reset the file input element
    $('#input-file-id').val('');

    // Clear file-related fields in the form
    let getform = this.changepasswordForm.value;
    getform.incubatorRegFileName = '';
    getform.incubatorRegFile = '';

    // Update the form with cleared values
    this.changepasswordForm.patchValue(getform);
  }
}
